import * as amplitude from "@amplitude/analytics-browser"
import { AnalyticsWindow } from "./analytics-window"
import { GTMPlugin, eventTrackingEnrichment } from "./analytics-plugins"
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser"
import { setConsentsDataOnUserProperty } from "./analytics-consents"
import analyticsWebVitals from "./analytics-web-vitals"

declare let window: AnalyticsWindow

interface AnalyticsLoaderProps {
  apiKey: string
  pageTheme: string
}

export default function analyticsLoader(
  _el: HTMLElement,
  props: AnalyticsLoaderProps,
) {
  amplitude.add(eventTrackingEnrichment(props.pageTheme))

  amplitude.add(GTMPlugin())

  amplitude.add(
    sessionReplayPlugin({
      forceSessionTracking: true,
      sampleRate: 0.01,
    }),
  )

  amplitude.init(props.apiKey, {
    optOut:
      window.parent.location.pathname.includes("/ca-admin") ||
      window.location.search.includes("optimizely"),
    autocapture: {
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  })

  analyticsWebVitals()

  document.addEventListener("cookieConsentPreferencesUpdated", () => {
    setConsentsDataOnUserProperty()
  })

  document.addEventListener("cookieConsentPreferencesAvailable", () => {
    setConsentsDataOnUserProperty()
  })

  document.addEventListener("consentOptInDefaultAvailable", () => {
    setConsentsDataOnUserProperty()
  })
}
